'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _ChartWrapper = require('components/ChartWrapper/ChartWrapper');

var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);

var _ChartNoData = require('components/Statistics/ChartNoData/ChartNoData');

var _ChartNoData2 = _interopRequireDefault(_ChartNoData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var DevicesChart = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(DevicesChart, _PureComponent);

  function DevicesChart() {
    (0, _classCallCheck3.default)(this, DevicesChart);
    return (0, _possibleConstructorReturn3.default)(this, (DevicesChart.__proto__ || (0, _getPrototypeOf2.default)(DevicesChart)).apply(this, arguments));
  }

  (0, _createClass3.default)(DevicesChart, [{
    key: 'getChartData',
    value: function getChartData() {
      var data = this.props.data.data;
      var _context = this.context,
          t = _context.t,
          _t = _context.t;


      return [[t('Device'), t('Count')]].concat((0, _toConsumableArray3.default)(data.map(function (stat) {
        return [_t(stat[0]), stat[1]];
      })));
    }
  }, {
    key: 'getChartProps',
    value: function getChartProps() {
      var id = this.props.id;

      var data = this.getChartData();

      return {
        graphId: id,
        chartType: 'PieChart',
        data: data,
        options: {
          is3D: false,
          pieHole: 0.4,
          chartArea: {
            left: 10,
            top: 10,
            width: '80%'
          },
          legend: {
            position: 'right',
            alignment: 'top'
          }
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          hasData = _props.data.hasData,
          loading = _props.loading,
          reverseColors = _props.reverseColors;

      var chartProps = this.getChartProps();

      if (!hasData && !loading) {
        return _react2.default.createElement(_ChartNoData2.default, null);
      }

      return _react2.default.createElement(_ChartWrapper2.default, {
        chartProps: chartProps,
        height: 240,
        loading: loading,
        reverseColors: reverseColors
      });
    }
  }]);
  return DevicesChart;
}(_react.PureComponent), _class2.propTypes = {
  data: _propTypes2.default.object,
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  reverseColors: _propTypes2.default.bool
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  data: { data: [], hasData: false },
  id: 'devicesChart',
  reverseColors: false
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'getChartData', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'getChartData'), _class.prototype)), _class);
exports.default = DevicesChart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/DevicesChart/DevicesChart.js
// module id = 520
// module chunks = 1